import Header from '../Components/Header';
import Footer from '../Components/Footer';
import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { canonicalUrl } from '../siteConfig';

function Home() {
    useEffect(() => {
        const $ = window.$;

        $('.owl-one').owlCarousel({
            loop: true,
            margin: 0,
            nav: false,
            responsiveClass: true,
            autoplay: true,
            autoplayTimeout: 9000,
            autoplaySpeed: 2000,
            autoplayHoverPause: false,
            responsive: {
                0: {
                    items: 1
                },
                480: {
                    items: 1
                },
                667: {
                    items: 1
                },
                1000: {
                    items: 1
                }
            }
        })
        $("#owl-demo1").owlCarousel({
            loop: true,
            margin: 20,
            nav: false,
            autoplay: true,
            responsiveClass: true,
            autoplaySpeed: 1000,
            autoplayTimeout: 5000,
            autoplayHoverPause: false,
            responsive: {
                0: {
                    items: 1,
                    nav: false
                },
                736: {
                    items: 1,
                    nav: false
                },
                1000: {
                    items: 1,
                    nav: false,
                    loop: false
                }
            }
        })
        $(window).on("scroll", function () {
            var scroll = $(window).scrollTop();

            if (scroll >= 80) {
                $("#site-header").addClass("nav-fixed");
                $("#main-logo").attr("src", "assets/images/logo-black.png");
            } else {
                $("#site-header").removeClass("nav-fixed");
                $("#main-logo").attr("src", "assets/images/logo.png");
            }
        });

        //Main navigation Active Class Add Remove
        $(".navbar-toggler").on("click", function () {
            $("header").toggleClass("active");
        });
        $(document).on("ready", function () {
            if ($(window).width() > 991) {
                $("header").removeClass("active");
            }
            $(window).on("resize", function () {
                if ($(window).width() > 991) {
                    $("header").removeClass("active");
                }
            });
        });

        $('.owl-carousel').each(function () {
            //Find each set of dots in this carousel
            $(this).find('.owl-dot').each(function (index) {
                //Add one to index so it starts from 1
                $(this).attr('aria-label', index + 1);
            });
        });

        window.onscroll = function () {
            scrollFunction()
        };

        function scrollFunction() {
            if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
                document.getElementById("movetop").style.display = "block";
            } else {
                document.getElementById("movetop").style.display = "none";
            }
        }

    });

    return (
        <div style={{ textAlign: "left" }}>
            <Helmet>
                <title>Solace Integrations | Network Infrastructure Design | Westchester, NY</title>
                <link rel="canonical" href={canonicalUrl('/')} />
                <meta name="description" content="Solace Integrations designs and builds network and IT infrastructure for small and mid-sized businesses in Westchester and Fairfield Counties. Network design, cloud systems, storage, and as-built documentation for upgrades, relocations, and new construction." />
            </Helmet>
            <Header />

            <section className="w3l-main-slider banner-slider" style={{ marginTop: "44px" }} id="home">
                <div className="owl-one owl-carousel owl-theme">
                    <div className="item">
                        <div className="slider-info banner-view banner-top2">
                            <div className="container">
                                <div className="banner-info header-hero-19">
                                    <p className="text-tag" style={{ marginBottom: "4px" }}>What We Do</p>
                                    <h1 className="title-hero-19" style={{ margin: "6px 0 8px" }}>Network Infrastructure & IT System Design</h1>
                                    <p className="d-none d-md-block" style={{ color: "rgba(255,255,255,0.75)", fontSize: "14px", marginBottom: "16px", fontWeight: 400 }}>
                                        Professional network and IT system design in Westchester and Fairfield Counties.
                                    </p>
                                    <div className="d-grid grid-col-3 mai-hero-19" style={{ gap: "10px" }}>
                                        {[
                                            { icon: "fa-network-wired", label: "Network Design & Installation" },
                                            { icon: "fa-file-alt",      label: "As-Built Network Documentation" },
                                            { icon: "fa-cloud",         label: "Cloud & Identity Systems", third: true },
                                            { icon: "fa-globe",         label: "Domain & DNS Management" },
                                            { icon: "fa-database",      label: "Storage & Backup Systems" },
                                            { icon: "fa-shield-alt",    label: "Firewall & Network Security", third: true },
                                        ].map(({ icon, label, third }) => (
                                            <a
                                                key={label}
                                                href="services"
                                                className={"grid-hero-19" + (third ? " third-gdw3" : "")}
                                                style={{
                                                    background: "rgba(255,255,255,0.10)",
                                                    backdropFilter: "blur(6px)",
                                                    WebkitBackdropFilter: "blur(6px)",
                                                    border: "1px solid rgba(255,255,255,0.18)",
                                                    borderRadius: "12px",
                                                    padding: "4px 6px",
                                                    textDecoration: "none",
                                                    transition: "background 0.2s, transform 0.2s",
                                                    display: "grid",
                                                    alignItems: "center",
                                                    gridTemplateColumns: "1fr 3fr",
                                                    gap: "10px",
                                                }}
                                                onMouseEnter={e => { e.currentTarget.style.background = "rgba(255,255,255,0.18)"; e.currentTarget.style.transform = "translateY(-2px)"; }}
                                                onMouseLeave={e => { e.currentTarget.style.background = "rgba(255,255,255,0.10)"; e.currentTarget.style.transform = "translateY(0)"; }}
                                            >
                                                <span className={"fas " + icon} style={{ background: "none", color: "#96beff", fontSize: "20px" }}></span>
                                                <div className="right-cont-19">
                                                    <h5 style={{ margin: 0 }}>
                                                        <span style={{ color: "#ffffff", fontSize: "13px", lineHeight: "20px", fontWeight: 600, background: "none" }}>{label}</span>
                                                    </h5>
                                                </div>
                                            </a>
                                        ))}
                                    </div>
                                    <div className="w3banner-buttons" style={{ marginTop: "10px" }}>
                                        <a href="/services" className="btn btn-style solace-btn-primary">View All Services</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="item">
                        <div className="slider-info banner-view banner-top3">
                            <div className="container">
                                <div className="banner-info header-hero-19">
                                    <p className="text-tag">Contact Us</p>
                                    <h1 className="title-hero-19" style={{ marginBottom: "0px" }}>Planning a New Technology Project or Infrastructure Upgrade?</h1>
                                    <div className="w3banner-buttons">
                                        <a href="/contact" className="btn btn-style solace-btn-primary mt-sm-5 mt-4">Contact Us</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>

            <div className="w3l-3-grids py-5" id="grids-3">
                <div className="container py-md-5 py-2">

                    <div className="row">
                        <div className="col-lg-8 pr-lg-3 mb-3">
                            <div className="title-content text-left">
                                <h6 className="solace-title-subhny mb-2">About Us</h6>
                                <h1 className="title-w3l">Your Local Technology Company</h1>
                            </div>
                        </div>

                    </div>
                    <div className="mt-lg-0 mt-md-5 mt-4 mb-3 text-left">

                        <p className="pr-lg-5">Solace Integrations is a network and IT infrastructure consulting firm serving businesses in Westchester and Fairfield Counties. We work with small and mid-sized businesses on technology upgrades, office relocations, renovations, and new construction, designing the network, security, cloud, and data systems your environment requires. When your project involves contractors or a build-out, we coordinate with your team and deliver the documentation to support it.</p>
                        <div className="w3banner-buttons">
                            <a href="/services" className="btn btn-style solace-btn-primary mt-sm-3 mb-4">View All Services</a>
                        </div>
                    </div>

                    <div id="brands" className="row">
                        <div className="col-lg-6 pr-lg-3 mb-3">
                            <div className="title-content text-left">
                                <h6 className="solace-title-subhny mb-2">Brands We Use</h6>
                                <h1 className="title-w3l">Industry Respected Brands</h1>
                            </div>
                        </div>

                    </div>

                    <div className="row pt-md-0 pt-5">
                        <div className="col-lg-4 col-6 mt-2">
                            <a href="https://synology.com" target="_blank" className="d-block zoom">

                                <div className="grids3-info">
                                    <img src="assets/images/synology-logo.webp" alt="Synology Logo" className="img-fluid news-image" />

                                </div>
                            </a>

                        </div>
                        <div className="col-lg-4 col-6 mt-2">
                            <a href="https://www.ui.com" target="_blank" className="d-block zoom">

                                <div className="grids3-info">
                                    <img src="assets/images/ubiquiti-logo_processed.png" alt="Ubiquiti Logo" className="img-fluid news-image" />

                                </div>
                            </a>

                        </div>
                        <div className="col-lg-4 col-6 mt-2">
                            <a href="https://www.microsoft.com" target="_blank" className="d-block zoom">

                                <div className="grids3-info">
                                    <img src="assets/images/microsoft-logo.webp" alt="Microsoft Logo" className="img-fluid news-image" />

                                </div>
                            </a>

                        </div>
                    
                    </div>
                </div>
            </div>

            <section style={{ background: "#f5f8fb", padding: "60px 0" }} id="how-we-work">
                <div className="container">
                    <div className="row mb-5">
                        <div className="col-lg-8">
                            <h6 className="solace-title-subhny mb-2">Our Process</h6>
                            <h1 className="title-w3l">How We Work</h1>
                        </div>
                    </div>
                    <div className="how-we-work-grid">
                        {[
                            {
                                num: "01",
                                title: "Consult & Scope",
                                desc: "We start by understanding your environment, goals, timeline, and any existing infrastructure to define the scope of work."
                            },
                            {
                                num: "02",
                                title: "Design & Plan",
                                desc: "We produce a detailed infrastructure design covering network layout, equipment selection, system configuration, and integration requirements."
                            },
                            {
                                num: "03",
                                title: "Deploy & Configure",
                                desc: "We install and configure all systems on-site, coordinating with contractors or project teams as needed throughout the process."
                            },
                            {
                                num: "04",
                                title: "Document & Hand Off",
                                desc: "We deliver complete as-built documentation so your team, your tenants, or future contractors have a clear record of what was built."
                            },
                        ].map(({ num, title, desc }, i, arr) => (
                            <div key={num} style={{ paddingRight: i < arr.length - 1 ? "32px" : "0" }}>
                                <div style={{ display: "flex", alignItems: "center", marginBottom: "20px" }}>
                                    <div style={{
                                        width: "44px", height: "44px", borderRadius: "50%",
                                        background: "var(--primary-color)", color: "#fff",
                                        display: "flex", alignItems: "center", justifyContent: "center",
                                        fontWeight: 700, fontSize: "15px", flexShrink: 0
                                    }}>{num}</div>
                                    {i < arr.length - 1 && (
                                        <div className="connector-line" style={{ flex: 1, height: "2px", background: "linear-gradient(to right, var(--primary-color), #ccdff0)", marginLeft: "12px" }} />
                                    )}
                                </div>
                                <h5 style={{ fontWeight: 700, fontSize: "16px", marginBottom: "10px" }}>{title}</h5>
                                <p style={{ color: "#666", fontSize: "14px", lineHeight: "22px", margin: 0 }}>{desc}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <section className="w3l-featureshny py-5" id="features">
                <div class="container py-md-5">
                    <div class="row">
                        <div className="col-lg-5 pr-lg-5 mb-lg-0 mb-5">
                            <div className="w3l-header-sec text-left mb-md-5 mb-4">
                                <h6 class="mt-1 mb-2" style={{ color: "#c7ddec" }}>About Us</h6>
                                <h1 style={{ color: "white" }} class="">View Our Team of Technology Experts</h1>
                                <a href="/team" class="btn solace-btn-primary btn-white btn-style mt-lg-5 mt-4">Our Team</a>
                            </div>
                        </div>

                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default Home;